export enum TemplateType {
    DEFAULT = 1,
    CATALOG = 2,
}